"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    class: "board-cont moon-board",
    id: "moon_board"
};
const _hoisted_2 = {
    id: "moon_board_outer_spaces",
    class: "board-outer-spaces"
};
const _hoisted_3 = { class: "global-numbers" };
const _hoisted_4 = { class: "global-numbers-habitat" };
const _hoisted_5 = { class: "global-numbers-logistics" };
const _hoisted_6 = { class: "global-numbers-mining" };
const _hoisted_7 = {
    class: "board",
    id: "moon_board"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MoonSpace = (0, vue_1.resolveComponent)("MoonSpace");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        _cache[0] || (_cache[0] = (0, vue_1.createStaticVNode)("<svg id=\"moon_board_legend\" height=\"550\" width=\"630\" class=\"board-legend\"><g id=\"mare_imbrium\" transform=\"translate(250, 40)\"><text class=\"board-caption\"><tspan dy=\"15\">Mare</tspan><tspan x=\"12\" dy=\"12\">Imbrium</tspan></text><line x1=\"24\" y1=\"34\" x2=\"33\" y2=\"105\" class=\"board-line\"></line><text x=\"30\" y=\"107\" class=\"board-caption board_caption--black\">●</text></g><g id=\"mare_sereitatis\" transform=\"translate(485, 140)\"><text class=\"board-caption\"><tspan dy=\"15\">Mare</tspan><tspan x=\"4\" dy=\"12\">Serenitatis</tspan></text><line x1=\"0\" y1=\"25\" x2=\"-120\" y2=\"50\" class=\"board-line\"></line><text x=\"-122\" y=\"53\" class=\"board-caption board_caption--black\">●</text></g><g id=\"mare_nubium\" transform=\"translate(195, 350)\"><text class=\"board-caption\"><tspan dy=\"15\">Mare</tspan><tspan x=\"-2\" dy=\"12\">Nubium</tspan></text><line x1=\"29\" y1=\"14\" x2=\"115\" y2=\"-64\" class=\"board-line\"></line><text x=\"113\" y=\"-62\" class=\"board-caption board_caption--black\">●</text></g><g id=\"mare_nectaris\" transform=\"translate(450, 300)\"><text class=\"board-caption\" dx=\"47\"><tspan dy=\"15\">Mare</tspan><tspan dy=\"12\" x=\"48\">Nectaris</tspan></text><line x1=\"-39\" y1=\"-12\" x2=\"45\" y2=\"15\" class=\"board-line\"></line><text x=\"-39\" y=\"-9\" class=\"board-caption board_caption--black\">●</text></g></svg>", 1)),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createVNode)(_component_MoonSpace, {
                space: _ctx.getSpaceById('m01'),
                text: "Luna Trade Station"
            }, null, 8, ["space"]),
            (0, vue_1.createVNode)(_component_MoonSpace, {
                space: _ctx.getSpaceById('m37'),
                text: "Momentum Virium Habitat"
            }, null, 8, ["space"])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_3, [
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getValuesForParameter('habitat'), (lvl, i) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: (0, vue_1.normalizeClass)(_ctx.getScaleCSS(lvl)),
                        key: i
                    }, (0, vue_1.toDisplayString)(lvl.strValue), 3));
                }), 128))
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_5, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getValuesForParameter('logistics'), (lvl, i) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: (0, vue_1.normalizeClass)(_ctx.getScaleCSS(lvl)),
                        key: i
                    }, (0, vue_1.toDisplayString)(lvl.strValue), 3));
                }), 128))
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_6, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getValuesForParameter('mining'), (lvl, i) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: (0, vue_1.normalizeClass)(_ctx.getScaleCSS(lvl)),
                        key: i
                    }, (0, vue_1.toDisplayString)(lvl.strValue), 3));
                }), 128))
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_7, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getAllNonColonySpaces(), (space) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_MoonSpace, {
                    key: space.id,
                    space: space,
                    tileView: _ctx.tileView,
                    "data-test": "moon-board-space"
                }, null, 8, ["space", "tileView"]));
            }), 128))
        ])
    ]));
}
